// const API = process.env.REACT_APP_BACKEND
export const SWAP_API = process.env.REACT_APP_SWAP_API
export const GRAPH_ENDPOINT = process.env.REACT_APP_GRAPH_ENDPOINT

export default {}
